// workplacegiving/html/js/corp-2021/src/contact-us.js

import './_site-wide'

const form  = document.querySelector('#contact-form');
const psPartnerKeyInput = document.getElementById('ps-partner-key');
const fname = document.getElementById('fname');
const lname = document.getElementById('lname');
const org   = document.getElementById('org');
// const orgType = document.getElementById('org-type');
const employeeCount = document.getElementById('employee-count');
const email = document.getElementById('email');
const phone = document.getElementById('phone');
// const notes = document.getElementById('notes');

/**
 * Form validation and submission handling. Uses HTML5 form validation.
 * On form submission, it prevents the default behavior, checks if the
 * form is valid, and if so, submits the form. If the form is invalid,
 * it adds the 'was-validated' class to trigger Bootstrap's validation styles.
 * On form reset, it removes the 'was-validated' class to reset the validation state.
 */
form.addEventListener('submit', (event) => {
  event.preventDefault();
  form.classList.add('was-validated');
  if (form.checkValidity()) {
    partnerStackSignUp(() => {
      form.submit();
    });
  } else {
    return false;
  }
});

/**
 * Event listener for form reset. When the form is reset, it removes
 * the 'was-validated' class to clear any validation styles that
 * were applied, allowing the form to return to its initial state
 * without any validation feedback.
 */
form.addEventListener('reset', () => {
  form.classList.remove('was-validated');
});


/**
 * Function to handle PartnerStack sign-up. It collects user input from
 * the form fields, populates the growsumo.data object with the user's
 * name and email, and sets a unique customer key based on the email.
 * Additionally, it adds a custom property to track the page location
 * of the signup. Finally, it calls growsumo.createSignup() to register
 * the signup with PartnerStack.
 * 
 *    Properties      growsumo name
 *    -------------   -------------
 *    Customer Name   `name`
 *    Email           `email`
 *    Company Name    `company_name`
 *    Website         ❌
 *    Phone Number    `phone`
 *    # of Employees  `employee_count`
 *    Customer Key    `customer_key` email
 */
function partnerStackSignUp(onComplete) {
  // Set the PartnerStack partner key in the hidden input field if it's not empty
  if (growsumo.data.partner_key.trim() !== '') {
    psPartnerKeyInput.value = growsumo.data.partner_key;
  }
  // 1. Populate the growsumo.data object
  growsumo.data.name = `${fname.value} ${lname.value}`; //fname.value + ' ' + lname.value;
  growsumo.data.email = email.value;
  growsumo.data.customer_key = email.value; // How we uniquely identify customers

  // Adding custom properties
  growsumo.data.meta = growsumo.data.meta ?? {}; // Initialize meta if it doesn't exist

  // Merge custom properties into growsumo.data.meta using Object.assign
  Object.assign(growsumo.data.meta,
  {
    employee_count: toIntOrString(employeeCount.value),
    company_name: org.value.trim(),
    phone: phone.value.trim()
  });

  // Register the signup with PartnerStack
  growsumo.createSignup(onComplete);
}

function toIntOrString(value) {
  if (typeof value === "string" && value.trim() === "") return value;
  const n = Number(value);
  return Number.isNaN(n) ? value : n;
}
